/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespMainContent_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly displayUriRef: string | null;
    readonly displayMaxNumberOfPages: number | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_itemSearch" | "SbRespContentModuleSelector_itemSearch" | "SbRespSortItems_itemSearch" | "SbRespPageSize_itemSearch" | "SbRespBrowseHeader_itemSearch" | "SbRespSearchResultContainer_itemSearch" | "SbSharedRelatedItems_itemSearch" | "SbRespRefineTopNav_itemSearch">;
    readonly " $refType": "SbRespMainContent_itemSearch";
};
export type SbRespMainContent_itemSearch$data = SbRespMainContent_itemSearch;
export type SbRespMainContent_itemSearch$key = {
    readonly " $data"?: SbRespMainContent_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespMainContent_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayMaxNumberOfPages",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleSelector_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespPageSize_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespBrowseHeader_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopNav_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '15f03c676f7a5c231c747af1b6ded2b8';
export default node;
